import './Loader.css';
export default function Loader() {
  return (
    /* From Uiverse.io by codingzemigle */
    <div className="w-full min-h-[100vh] flex justify-center items-center">
      <div className="spinner"></div>
    </div>
  );
}
